import * as types from './types';
import { loading, success, error } from 'State/actions';
import { resetDirty } from 'State/dirtyTracking/actions';

export const getConsolidateOrderDetail = model => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.GET_CONSOLIDATE_ORDER_LOADING, true));

    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        `Order/ConsolidateOrder`,
        model
      );
      dispatch(success(types.SET_CONSOLIDATE_DATA, response.data.Data));
    } catch (ex) {
      dispatch(error(types.GET_CONSOLIDATE_ORDER_LOADING_ERROR, ex));
    } finally {
      dispatch(loading(types.GET_CONSOLIDATE_ORDER_LOADING, false));
    }
  };
};
export const setConsolidateApiModelData = model => {
  return {
    type: types.SET_CONSOLIDATE_API_MODEL_DATA,
    payload: model,
  };
};

export const emptyGridConsolidateData = () => {
  return {
    type: types.SET_CONSOLIDATE_DATA,
    payload: {
      ConsolidateManagerModel: [],
      OrderConsolidatedVerification: null,
      WHAssociation: [],
    },
  };
};
export const processConsolidateOrder = (model, redirectToRootPage) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.PROCESS_CONSOLIDATE_ORDER_LOADING, true));

    try {
      await MPWWebApi.postGenericInsertUpdate(
        `Order/ProcessConsolidateOrder`,
        model
      );
      dispatch(resetDirty());
      dispatch(success(types.PROCESS_CONSOLIDATE_DATA));
      redirectToRootPage();
    } catch (ex) {
      dispatch(error(types.PROCESS_CONSOLIDATE_ORDER_LOADING_ERROR, ex));
    } finally {
      dispatch(loading(types.PROCESS_CONSOLIDATE_ORDER_LOADING, false));
    }
  };
};

export const clearProcessSubmitError = () => {
  return {
    type: types.CLEAR_CONSOLIDATE_ORDER_ERROR,
  };
};
export const clearOrderConsolidatedVerificationMsg = () => {
  return {
    type: types.CLEAR_ORDER_CONSOLIDATE_VERIFICATION_MSG,
  };
};



// WEBPACK FOOTER //
// ./src/pages/inventory/manageprocessorder/state/consolidate/actions.js